module.exports = __webpack_public_path__ + "static/media/icon_notice_sp.b69b6a38.svg";